import React, { useCallback, useMemo, useRef, useState } from 'react'
import { TreeSelect } from 'primereact/treeselect';
import { InputText } from 'primereact/inputtext';
import { classNames } from "primereact/utils";
import { Trans, useTranslation } from 'react-i18next';
import { FormatCurrency, useCurrencyConstants } from '../../../../Components/CurrencyFormatter';
import { Tooltip } from 'primereact/tooltip';
import {
    TreeSelectLabelTooltip,
    treeSelectNodeTemplate,
    treeSelectValueTemplate,
    withTruncatedTreeLabels,
} from '../../../../Components/TreeSelectLabelHelpers';
import AutoBillingBadge from '../../../../Components/AutoBillingBadge';
// import { useSelector } from 'react-redux';


export const PlanTreeSelect = (props) => {
    const { state, initialTier, fromSubscriberImport, planTierSelect, isFormFieldValid, csvFileData, selectedData, getFormErrorMessage } = props;
    const { t } = useTranslation("common");
    const { currencyFormat, currencySymbol } = useCurrencyConstants();

    const treeSelectRef = useRef(null);
    const [filterValue, setFilterValue] = useState('');
    const [manualExpandedKeys, setManualExpandedKeys] = useState({});

    //redux state
    // const planGroupsGraphedActive = useSelector((state) => state.planGroups.planGroupsGraphedActive)

    // const [treeState, setTreeState] = useState({
    //     selectOptions:[]
    // })

    // useEffect(() => {
    //     const nonArchivedGroups = planGroupsGraphedActive?.groups?.map((group) => {
    //         const nonArchivedPlans = group.plans.filter((plan) => !plan.status.includes("ARCHIVED"));
    //         return {
    //             ...group,
    //             plans: nonArchivedPlans,
    //         };
    //     })

    //     if (nonArchivedGroups) {
    //         let planGroupAssigned = [];
    //         nonArchivedGroups.map((item, ind) => {
    //             const {
    //                 group: { id },
    //                 group,
    //                 plans,
    //             } = item;

    //             planGroupAssigned.push({
    //                 key: id,
    //                 label: group.name,
    //                 selectable: false,
    //                 data: group,
    //                 children:
    //                     plans === null
    //                         ? []
    //                         : plans.map((item, idx) => ({
    //                             key: `${ind}-${idx}`,
    //                             label: item.name,
    //                             data: item,
    //                         })),
    //             });
    //             setTreeState((prev) => {
    //                 return {
    //                     ...prev,
    //                     selectOptions: planGroupAssigned
    //                 }
    //             })
    //             return null;
    //         });
    //     }
    // }, [planGroupsGraphedActive])


    const handleFilter = (e) => {
        const value = e.target.value;
        setFilterValue(value);
    };

    const handleToggle = (e) => {
        if (!filterValue) {
            setManualExpandedKeys(e.value);
        }
    };

    const filterTree = useCallback((nodes, term) => {
        if (!term) return nodes;

        const lowerTerm = term.toLowerCase();
        const filtered = [];

        nodes.forEach(node => {
            const searchableLabel = (node.fullLabel ?? node.label ?? '').toLowerCase();
            const nodeMatches = searchableLabel.includes(lowerTerm);

            let filteredChildren = [];
            if (node.children) {
                filteredChildren = filterTree(node.children, term);
            }

            if (nodeMatches || filteredChildren.length > 0) {
                const newNode = { ...node };

                if (filteredChildren.length > 0) {
                    newNode.children = filteredChildren;
                } else {
                    delete newNode.children;
                }

                filtered.push(newNode);
            }
        });

        return filtered;
    }, []);

    const getExpandedKeys = useCallback((filteredNodes) => {
        const keys = {};

        const traverse = (nodes) => {
            nodes.forEach(node => {
                if (node.children) {
                    keys[node.key] = true;
                    traverse(node.children);
                }
            });
        };

        traverse(filteredNodes);
        return keys;
    }, []);

    const selectedProducts = state.selectOptions.filter(item => item.children.length > 0)


    const selectedProductsForSubscriberImport = state.selectOptions
        .map(item => {
            const filteredChildren = item?.children?.filter(child =>
                child?.data.policy === "FIXED" || child?.data.policy === "FLEXIBLE"
            );

            if (filteredChildren && filteredChildren.length > 0) {
                return { ...item, children: filteredChildren };
            }

            return null;
        }).filter(Boolean)

    const currentOptions = fromSubscriberImport ? selectedProductsForSubscriberImport : selectedProducts;

    const displayOptions = useMemo(
        () => withTruncatedTreeLabels(currentOptions),
        [currentOptions]
    );

    const filteredOptions = filterValue ? filterTree(displayOptions, filterValue) : displayOptions;

    const expandedKeys = filterValue ? getExpandedKeys(filteredOptions) : manualExpandedKeys;

    const filterTemplate = () => {
        return (
            <InputText
                placeholder={t("invitation.filterholder")}
                value={filterValue}
                onChange={handleFilter}
            />
        );
    };

    const amountFunc = () => {
        if ((selectedData()?.data.policy === "CUSTOM" || initialTier?.data.policy === "CUSTOM")
            && (!selectedData()?.data.cost || !initialTier?.data.cost)) {
            return <span className="inv_amt_des">{t("amount_fixed")}</span>
        }
        if (selectedData()?.data.policy === "TARGET" || initialTier?.data.policy === "TARGET") {
            return <span className="inv_amt_des">{t("products.target-fixed")}</span>
        }
        if (selectedData()?.data.policy === "FLEXIBLE" || initialTier?.data.policy === "FLEXIBLE") {
            return <span className="inv_amt_des">{t("products.flexible-amount")}</span>
        }
        if (selectedData()?.data.policy === "FIXED" && selectedData()?.data.cost) {
            return <FormatCurrency
                amount={selectedData()?.data.cost}
                currencySymbol={currencySymbol}
                currencyFormat={currencyFormat}
                className="planInfo" />
        }
        if (initialTier?.data.policy === "FIXED" && initialTier?.data.cost) {
            return <FormatCurrency
                amount={initialTier?.data.cost}
                currencySymbol={currencySymbol}
                currencyFormat={currencyFormat}
                className="planInfo" />
        } else { <span></span> }
    }

    return (
        <div>
            <div className="invite" style={{ marginBottom: "0.25rem" }}>
                {fromSubscriberImport ? <p><Trans
                    i18nKey="invitation.invite_to_list_title"
                    values={{ csv: csvFileData?.importName }}
                    components={{ 1: <span className="csv_name" /> }}
                /></p> : null}
                <div className="title flex"><p className="labels">{t("invitation.subscription_plan")}</p><p className="isterik">*</p></div>
                {(!initialTier || fromSubscriberImport) ?
                    <>
                        <TreeSelectLabelTooltip />
                        <TreeSelect
                            ref={treeSelectRef}
                            id="no-hover"
                            name="plan_tier"
                            value={!initialTier ? state.selectedNodeKey : initialTier.key}
                            options={filteredOptions}
                            onChange={planTierSelect}
                            filter
                            filterBy="fullLabel,label"
                            filterTemplate={filterTemplate}
                            expandedKeys={expandedKeys}
                            onToggle={handleToggle}
                            disabled={initialTier}
                            placeholder={t("invitation.plan_select")}
                            style={{ height: "3rem" }}
                            className={classNames({
                                "p-invalid": isFormFieldValid("plan_tier"),
                            })}
                            nodeTemplate={treeSelectNodeTemplate}
                            valueTemplate={treeSelectValueTemplate}
                        />
                    </>
                    : <span>
                        <InputText
                            id="no-hover"
                            name="tier"
                            aria-describedby="tier-help"
                            style={{ height: "3rem" }}
                            value={initialTier.label}
                            disabled
                        />
                        <AutoBillingBadge collectionMode={initialTier?.data.collectionMode} />
                    </span>}
                <label
                    htmlFor="plan_tier"
                    className={classNames({
                        "p-error": isFormFieldValid("plan_tier"),
                    })}
                ></label>
            </div>

            {!!(selectedData()?.data || initialTier?.data) && (
                <div>
                    <Tooltip
                        target=".target-icon"
                        className="planInfoTooltip"
                    >
                        <div className="planInfo-div">
                            <AutoBillingBadge
                                collectionMode={selectedData()?.data.collectionMode || initialTier?.data.collectionMode}
                            />
                            {selectedData()?.data.description ? (
                                <span className="planInfoDesc">
                                    {selectedData()?.data.description}
                                </span>
                            ) : null}
                            {initialTier?.data.description ? (
                                <span className="planInfoDesc">
                                    {initialTier?.data.description}
                                </span>
                            ) : null}

                            {(selectedData()?.data.policy) ?
                                <div className="mb-1">
                                    {(selectedData()?.data.policy === "TARGET") ?
                                        <div className="flex-direction">
                                            <span className="text-left policy mr-2">{t('billing', { val: selectedData()?.data.policy })}</span>
                                            <span className="text-left policy target-stat mb-0 mr-2">{selectedData()?.data.targetEqualParts ?
                                                t("product.equal") : t("product.varying")}</span>
                                            {((selectedData()?.data.targetEqualParts) && (selectedData()?.data.recoverMissed)) ?
                                                <span className="text-left policy target-stat-miss mb-0">{t('product.recovery')}</span> : null}
                                        </div>
                                        : <div>
                                            <span className="text-left policy">
                                                {selectedData()?.data.policy === "FIXED" ? t("products.fixed_billing").toUpperCase()
                                                    : t('billing', { val: selectedData()?.data.policy })}
                                            </span>
                                            <div>
                                            </div>
                                        </div>
                                    }
                                </div> : null}

                            {(initialTier?.data.policy) ?
                                <div className="mb-1">
                                    {(initialTier?.data.policy === "TARGET") ?
                                        <div className="flex-direction">
                                            <span className="text-left policy mr-2">{t('billing', { val: initialTier?.data.policy })}</span>
                                            <span className="text-left policy target-stat mb-0 mr-2">{initialTier?.data.targetEqualParts ?
                                                t("product.equal") : t("product.varying")}</span>
                                            {((initialTier?.data.targetEqualParts) && (initialTier?.data.recoverMissed)) ?
                                                <span className="text-left policy target-stat-miss mb-0">{t('product.recovery')}</span> : null}
                                        </div>
                                        : <div>
                                            <span className="text-left policy">
                                                {initialTier?.data.policy === "FIXED" ? t("products.fixed_billing").toUpperCase()
                                                    : t('billing', { val: initialTier?.data.policy })}
                                            </span>
                                            <div>
                                            </div>
                                        </div>
                                    }
                                </div> : null}

                            <div style={{ marginBottom: "0.5rem" }}>
                                {/* Amount info */}
                                <div style={{ margin: "0rem 0.5rem 0rem 0rem" }}>
                                    <span>{amountFunc()}</span>
                                </div>

                                {/* Billing info */}
                                <div className="mb-0.5">
                                    <span className="planInfoBillingPeriod">
                                        {t(`product.${(selectedData()?.data.billingPeriod || initialTier?.data.billingPeriod)?.toLowerCase()}`)}
                                    </span>
                                </div>

                                {/* Deductions */}
                                {(selectedData()?.data.deductions || initialTier?.data.deductions) ? (
                                    <div className="flex-direction">
                                        <span className="num-payments">
                                            {selectedData()?.data.deductions || initialTier?.data.deductions}
                                        </span>
                                        <span className="num-payments">{t("common.payments")}</span>
                                    </div>
                                ) : null}
                            </div>

                            <div>
                                {/* Setup Fee */}
                                {(selectedData()?.data.setup || initialTier?.data.setup) ? (
                                    <div className="mb-1 flex-direction">
                                        <span className="setup_plan_info_label">{t("product.setupFee")}</span>
                                        <FormatCurrency
                                            amount={selectedData()?.data.setup ? selectedData()?.data.setup : initialTier?.data.setup}
                                            currencySymbol={currencySymbol}
                                            currencyFormat={currencyFormat}
                                            className="setup_plan_info" />
                                    </div>
                                ) : null}
                                {/* Grace Period */}
                                {(selectedData()?.data.graceDays || initialTier?.data.graceDays) ? (
                                    <div className="mb-0.5 mt-1 flex-direction">
                                        <span className="planInfo_label">{t("grace_period")}: </span>
                                        <span className="planInfo_value">
                                            {selectedData()?.data.graceDays || initialTier?.data.graceDays} {t("invitation.day")}
                                        </span>
                                    </div>
                                ) : null}

                                {/* Reminder Days */}
                                {(selectedData()?.data.reminderDays || initialTier?.data.reminderDays) ? (
                                    <div className="mb-0.5 flex-direction">
                                        <span className="planInfo_label">{t("plan.reminder_label")}: </span>
                                        <span className="planInfo_value">
                                            {selectedData()?.data.reminderDays || initialTier?.data.reminderDays} {t("invitation.day")}
                                        </span>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </Tooltip>

                    <div className="mt-2">
                        <i
                            className="target-icon pi pi-info-circle"
                            data-pr-position="bottom"
                            style={{ fontSize: "12px", cursor: "pointer", color: "#495057", fontWeight: "600" }}
                        ></i>
                        <span style={{ fontSize: "12px", color: "#495057", paddingLeft: "4px", fontWeight: "600" }}>
                            {t("invitation.planDetailsInfo")}
                        </span>
                    </div>
                </div>
            )}

            <small id="tier-help" className="p-input-help">{getFormErrorMessage("plan_tier")}</small>
        </div>
    )
}
